<script lang="ts">
import type { VirtualAgent } from '@smartsupp/smartsupp-message'

import IdentityAvatar from '@/components/avatars/IdentityAvatar.svelte'
import { getAgentById } from '@/modules/agents'
import { getIdentityById } from '@/modules/botIdentities'

type Props = {
	agentId: string | null
	identityId?: string
	virtualAgent?: VirtualAgent | null
}

let { agentId, identityId, virtualAgent = null }: Props = $props()

let agent = $derived(getAgentById(agentId ?? ''))
let identity = $derived(getIdentityById(identityId || ''))
</script>

{#if virtualAgent || $agent || $identity}
	<div class="flex-center flex-shrink-0">
		<IdentityAvatar
			avatar={virtualAgent?.avatar || $identity?.avatarUrl || $agent?.avatar}
			isBot={!!identityId && !virtualAgent}
		/>
	</div>
	<div class="ml-3 mr-10 font-bold truncate color-slate-800">
		{virtualAgent?.name || $identity?.name || $agent?.fullname}
	</div>
{/if}
